import { gql } from '@apollo/client';

export const GIGS_QUERY = gql`
  query (
    $_sort: _SORTING
    $_page: Int
    $_perPage: Int
    $BudgetMax: String
    $BudgetMin: String
    $all: String
    $ProfessionCode: String
    $Skills: [String]
    $JobOrderTypeName: [String]
    $NearBy: NearByInput
    $ShowRateIn: _SHOW_RATE
    $FilterBudget: _SHOW_RATE
    $WorkplacePolicy: WorkplacePolicyInput
    $isPrivateGig: Boolean
    $countries: [String]
    $cities: [String]
    $regions: [String]
    $explevel: String
    $vms: [String]
    $facilityIds: [String]
    $JobOrderStatusName:String
    $MygigsProfileId: Int
  ) {
    gigs(
      _sort: $_sort
      _page: $_page
      _perPage: $_perPage
      BudgetMax: $BudgetMax
      BudgetMin: $BudgetMin
      all: $all
      Skills: $Skills
      JobOrderTypeName: $JobOrderTypeName
      NearBy: $NearBy
      ProfessionCode: $ProfessionCode
      ShowRateIn: $ShowRateIn
      FilterBudget: $FilterBudget
      WorkplacePolicy: $WorkplacePolicy
      isPrivateGig: $isPrivateGig
      countries: $countries
      cities: $cities
      regions: $regions
      explevel: $explevel
      vms: $vms
      facilityIds: $facilityIds
      JobOrderStatusName:$JobOrderStatusName
      MygigsProfileId: $MygigsProfileId
    ) {
      aggregate {
        count
        totalCount
        professionCodeCount {
          code
          count
        }
      }
      suggestion
      data {
        status {
          title
          count
        }
        _id
        JobOrderId
        VMS
        ProfileId
        Title
        isPrivate
        Description
        ZipCode
        OnSite
        FixedPrice
        Rate
        ExpiryDate
        Created
        CreatedBy
        Modified
        ModifiedBy
        IsActive
        Budget
        IdealTermsId
        BudgetRangeId
        ReasonId
        BudgetMin
        BudgetMax
        VisaStatusId
        SuggestionsFrequency
        SuggestionsSent
        InternalTitleId
        ImportSource
        ExternalGigId
        ImportProcessStatus
        FacilityName
        AutoLoaded
        SourceName
        SourceId
        CityName
        RegionCode
        score
        Specialty
        Shift
        WorkplacePolicy
        VMSLink
        Duration
        CompanyName
        isDisabled
        JobOrders_Skills {
          Id
          SkillPercent
          Skills {
            SkillId
            SkillCategoryId
            SkillName
            SkillCode
            SkillNameLowerCase
          }
        }
        JobOrders_VisaStatuses {
          VisaStatusId
        }
        InternalGigTypes {
          InternalGigTypeId
          InternalGigTypeCode
          InternalGigTypeName
          InternalGigTypeDescription
          Created
          CreatedBy
          Modified
          ModifiedBy
        }
        IdealContractLength {
          IdealContractLengthId
          IdealContractLengthName
          IdealContractLengthValue
          Created
          CreatedBy
          Modified
          ModifiedBy
        }
        Professions {
          ProfessionId
          ProfessionCode
          ProfessionName
          ProfessionDescription
          Created
          CreatedBy
          Modified
          ModifiedBy
        }
        ExperienceLevels {
          ExperienceLevelId
          ExperienceLevelCode
          ExperienceLevelName
          MinVal
          MaxVal
          SortOrder
          Created
          CreatedBy
          Modified
          ModifiedBy
        }
        JobOrderTypes {
          JobOrderTypeId
          JobOrderTypeName
          JobOrderTypeCode
          Created
          CreatedBy
          Modified
          ModifiedBy
        }
        Countries {
          CountryId
          CountryName
          FIPS104
          ISO2
          ISO3
          ISON
          Internet
          Capital
          MapReference
          NationalitySingular
          NationalityPlural
          Currency
          CurrencyCode
          Population
          Title
          Comment
        }
        Regions {
          RegionId
          CountryId
          RegionName
          Code
          ADM1Code
          TimeZone
        }
        Cities {
          CityId
          CountryId
          RegionId
          CityName
          Longitude
          Latitude
          TimeZone
          CityCode
        }
        BudgetTypes {
          BudgetTypeId
          BudgetTypeName
          BudgetTypeCode
          Created
          CreatedBy
          Modified
          ModifiedBy
          Order
        }
        JobOrderStatuses {
          JobOrderStatusId
          JobOrderStatusName
          JobOrderStatusCode
          Created
          CreatedBy
          Modified
          ModifiedBy
        }
        IsFavorite
        facilityRating {
          rating
          reviews
        }
        Skills {
          SkillName
          SkillPercent
        }
        Location {
          CityId
          CityName
          RegionId
          RegionCode
          LocationLong
          CountryId
          Location
          LocationWithCountry
          Latitude
          Longitude
          RegionName
          CountryName
        }
      }
    }
  }
`;

export const NEW_GIGS_QUERY = gql`
  query (
    $_sort: _SORTING
    $_page: Int
    $_perPage: Int
    $BudgetMax: String
    $BudgetMin: String
    $all: String
    $ProfessionCode: String
    $Skills: [String]
    $JobOrderTypeName: [String]
    $NearBy: NearByInput
    $ShowRateIn: _SHOW_RATE
    $FilterBudget: _SHOW_RATE
    $WorkplacePolicy: WorkplacePolicyInput
    $isPrivateGig: Boolean
    $countries: [String]
    $cities: [String]
    $regions: [String]
    $explevel: String
    $JobOrderStatusName:[String]
  ) {
    newGigs(
      _sort: $_sort
      _page: $_page
      _perPage: $_perPage
      BudgetMax: $BudgetMax
      BudgetMin: $BudgetMin
      all: $all
      Skills: $Skills
      JobOrderTypeName: $JobOrderTypeName
      NearBy: $NearBy
      ProfessionCode: $ProfessionCode
      ShowRateIn: $ShowRateIn
      FilterBudget: $FilterBudget
      WorkplacePolicy: $WorkplacePolicy
      isPrivateGig: $isPrivateGig
      countries: $countries
      cities: $cities
      regions: $regions
      explevel: $explevel
      JobOrderStatusName:$JobOrderStatusName
    ) {
      aggregate {
        count
        totalCount
        professionCodeCount {
          code
          count
        }
      }
      suggestion
      data {
        status {
          title
          count
        }
        _id
        JobOrderId
        VMS
        ProfileId
        Title
        isPrivate
        Description
        ZipCode
        OnSite
        FixedPrice
        Rate
        ExpiryDate
        Created
        CreatedBy
        Modified
        ModifiedBy
        IsActive
        Budget
        IdealTermsId
        BudgetRangeId
        ReasonId
        BudgetMin
        BudgetMax
        VisaStatusId
        SuggestionsFrequency
        SuggestionsSent
        InternalTitleId
        ImportSource
        ExternalGigId
        ImportProcessStatus
        FacilityName
        AutoLoaded
        SourceName
        SourceId
        CityName
        RegionCode
        score
        Specialty
        Shift
        WorkplacePolicy
        VMSLink
        Duration
        CompanyName
        isDisabled
        JobOrders_Skills {
          Id
          SkillPercent
          Skills {
            SkillId
            SkillCategoryId
            SkillName
            SkillCode
            SkillNameLowerCase
          }
        }
        JobOrders_VisaStatuses {
          VisaStatusId
        }
        InternalGigTypes {
          InternalGigTypeId
          InternalGigTypeCode
          InternalGigTypeName
          InternalGigTypeDescription
          Created
          CreatedBy
          Modified
          ModifiedBy
        }
        IdealContractLength {
          IdealContractLengthId
          IdealContractLengthName
          IdealContractLengthValue
          Created
          CreatedBy
          Modified
          ModifiedBy
        }
        Professions {
          ProfessionId
          ProfessionCode
          ProfessionName
          ProfessionDescription
          Created
          CreatedBy
          Modified
          ModifiedBy
        }
        ExperienceLevels {
          ExperienceLevelId
          ExperienceLevelCode
          ExperienceLevelName
          MinVal
          MaxVal
          SortOrder
          Created
          CreatedBy
          Modified
          ModifiedBy
        }
        JobOrderTypes {
          JobOrderTypeId
          JobOrderTypeName
          JobOrderTypeCode
          Created
          CreatedBy
          Modified
          ModifiedBy
        }
        Countries {
          CountryId
          CountryName
          FIPS104
          ISO2
          ISO3
          ISON
          Internet
          Capital
          MapReference
          NationalitySingular
          NationalityPlural
          Currency
          CurrencyCode
          Population
          Title
          Comment
        }
        Regions {
          RegionId
          CountryId
          RegionName
          Code
          ADM1Code
          TimeZone
        }
        Cities {
          CityId
          CountryId
          RegionId
          CityName
          Longitude
          Latitude
          TimeZone
          CityCode
        }
        BudgetTypes {
          BudgetTypeId
          BudgetTypeName
          BudgetTypeCode
          Created
          CreatedBy
          Modified
          ModifiedBy
          Order
        }
        JobOrderStatuses {
          JobOrderStatusId
          JobOrderStatusName
          JobOrderStatusCode
          Created
          CreatedBy
          Modified
          ModifiedBy
        }
        IsFavorite
        facilityRating {
          rating
          reviews
        }
        Skills {
          SkillName
          SkillPercent
        }
        Location {
          CityId
          CityName
          RegionId
          RegionCode
          LocationLong
          CountryId
          Location
          LocationWithCountry
          Latitude
          Longitude
          RegionName
          CountryName
        }
      }
    }
  }
`;
